import {formatCurrency} from '@angular/common';
import {Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {GridComponent, RowSelectEventArgs,} from '@syncfusion/ej2-angular-grids';
import {BenutzerModels} from 'src/app/models/benutzer-models';
import {ServiceAppModels} from 'src/app/models/serviceapp-models';
import {DatumFormatPipe} from 'src/app/pipes/datum-format.pipe';
import {MessageBoxService} from 'src/app/services/message-box.service';
import {ServiceAppService} from 'src/app/services/service-app.service';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';
import {ArtikelstammComponent} from './artikelstamm/artikelstamm.component';
import {PosMutationComponent} from './pos-mutation/pos-mutation.component';
import {BehaviorSubject} from 'rxjs';
import SA_ProductEntry = ServiceAppModels.SA_ProductEntry;

@Component({
    selector: 'app-rapport-positionen',
    templateUrl: './rapport-positionen.component.html',
    styleUrls: ['./rapport-positionen.component.scss'],
})
export class RapportPositionenComponent implements OnInit {
    @ViewChild('gridPositionen') public grid?: GridComponent;
    public positionsZeilen: BehaviorSubject<ServiceAppModels.SA_PositionZeile[]> = new BehaviorSubject([] as ServiceAppModels.SA_PositionZeile[]);
    public currTerminExists: boolean = false;
    public currTerminFinished: boolean = true;
    public isProductSelected: boolean = false;
    public totalSumme: number = 0.0;
    private currTermin?: ServiceAppModels.SA_Objekt;
    private currAnwender?: BenutzerModels.Anwender;
    private currProdukt?: ServiceAppModels.Produkt;
    private dataForArticleMutation?: ServiceAppModels.SA_DataForArticleMutation;
    private currProductEntry?: ServiceAppModels.SA_ProductEntry;
    private dbAuftragsProdukte?: ServiceAppModels.SA_ProductEntry[];

    constructor(
        //private localStorageService: LocalStorageService,
        private swissSettings: SwissSettingsService,
        private svcMessageBox: MessageBoxService,
        public dialog: MatDialog,
        private svcSA: ServiceAppService,
        private _datumFormatPipe: DatumFormatPipe
    ) {
        // Anwender asynchron laden
        this.svcSA.getAnwenderAsync().then((res) => {
                console.log('Rapport-positionen.component.ts: Anwender geladen: ', res);
                this.currAnwender = res;
            },
            (err) => console.error('rapport-positionen.component.ts => Fehler in getAnwenderAsnyc:', err)
        );
        if (this.swissSettings.getWebConfig().debugMode) {
            console.log('Rapport-Positionen: Constuctor fertig');
        }
    }

    ngOnInit(): void {
        if (this.swissSettings.getWebConfig().debugMode) {
            console.log('Rapport-Positionen: ngOnInit() - Start');
        }
        this.currTermin = this.svcSA.getTermin();
        if (this.currTermin) {
            this.currTerminExists = true;
            this.currTerminFinished = this.currTermin.serviceComplete === 1;
            this.loadProductEntries();
            //this.items = new DataManager(this.positionsZeilen).adaptor
        } else {
            this.currTerminExists = false;
        }
        this.svcSA.loadArticlesFromIndexedDB();
    }

    loadProductEntries() {
        this.totalSumme = 0.0;
        this.dbAuftragsProdukte = this.svcSA.getDBAuftragsProdukte();
        const arr: ServiceAppModels.SA_PositionZeile[] = [];
        // Die Produkte aus der DB in anschaubare Daten umwandeln
        for (let auftragsprodukt of this.dbAuftragsProdukte) {
            let posDatum = this._datumFormatPipe.transformOnlyDate(
                auftragsprodukt.datum
            );

            let myLaengeBreiteDicke = '';
            if (auftragsprodukt.laenge) {
                myLaengeBreiteDicke = String(auftragsprodukt.laenge);
            }

            if (auftragsprodukt.breite) {
                myLaengeBreiteDicke += '/' + String(auftragsprodukt.breite) + '/';
            }

            if (auftragsprodukt.dicke) {
                myLaengeBreiteDicke += String(auftragsprodukt.dicke);
            }

            let myPreisProEinheit = '';
            if (auftragsprodukt.preisProEinheit) {
                myPreisProEinheit = String(auftragsprodukt.preisProEinheit);
            }

            let myPreisTotal = '';
            if (auftragsprodukt.preisTotal) {
                this.totalSumme += auftragsprodukt.preisTotal;
                myPreisTotal = formatCurrency(
                    auftragsprodukt.preisTotal,
                    'de-CH',
                    'CHF',
                    '1.2-2'
                ).replace(',', '.');
            }

            let myAnzahl = '';
            if (auftragsprodukt.anzahl) {
                myAnzahl = String(auftragsprodukt.anzahl);
            }

            let positionszeile: ServiceAppModels.SA_PositionZeile = {
                servicePosID: auftragsprodukt.servicePosID,
                serviceID: auftragsprodukt.serviceID,
                datum: posDatum,
                mitarbeiter:
                    auftragsprodukt.mitarbeiter.firstName +
                    ' ' +
                    auftragsprodukt.mitarbeiter.lastName,
                artikelnummer: auftragsprodukt.artikelnummer,
                bezeichnung: auftragsprodukt.bezeichnung,
                anzahl: myAnzahl,
                einheit: auftragsprodukt.einheit,
                menge: auftragsprodukt.mengeTotal,
                laengeBreiteDicke: myLaengeBreiteDicke,
                preisProEinheit: myPreisProEinheit,
                preisTotal: myPreisTotal,
                preisTotalNum: auftragsprodukt.preisTotal,
                spesen: auftragsprodukt.spesen,
                kulanz: auftragsprodukt.kulanz,
            };
            arr.push(positionszeile);
        }
        this.positionsZeilen.next(arr);
    }

    // Die Felder Kulanz / Spesen erhalten je nach Wert ein anderes Image
    imgSrc(value?: boolean): string {
        let htmlStr: string = 'cancel.png';
        if (value) {
            htmlStr = 'ok.png';
        }
        return htmlStr;
    }

    /*
    reloadArticles(termin?: ServiceAppModels.SA_Objekt) {
      // Ausgewählter Termin aus der Agenda wird übergeben
      if (termin) {
        this.currTermin = termin;
        this.currTerminExists = true;
        console.log("currTerminExists nach setzen", this.currTerminExists);
      }
    }
    */

    public rowSelected(args: RowSelectEventArgs): void {
        let zeile = <ServiceAppModels.SA_PositionZeile> (
            this.grid!.getSelectedRecords()[0]
        );
        if (zeile) {
            this.currProductEntry = this.dbAuftragsProdukte?.filter(x => x.servicePosID === zeile.servicePosID)[0];
            this.isProductSelected = true;
        }
    }

    public rowDeselected(args: RowSelectEventArgs): void {
        this.currProductEntry = undefined;
        this.isProductSelected = false;
    }

    addArticle(): void {
        if (!this.currTerminExists) {
            this.svcMessageBox.showInfoByLangagueKey('MAIN_APP_SERVICE_APP.noAppointmentSelected', 'MAIN_APP_SERVICE_APP.noAppointmentSelected');
            return;
        }
        if (this.currTerminFinished) {
            return this.svcMessageBox.showWarning('Der Termin ist bereits abgeschlossen', '');
        }

        if (!this.currAnwender) {
            console.error('addArticle: Anwender nicht geladen!!!!!');
            this.currAnwender = this.svcSA.getAnwender();
            if (!this.currAnwender) {
                console.error('addArticle: Anwender immer noch nicht geladen!!!!!');
            }
        }

        const chosenArticle = this.currProdukt;

        this.dataForArticleMutation = {
            sA_Termin: this.currTermin,
            sA_Anwender: this.currAnwender,
            produkt: this.currProdukt,
            editProdukt: undefined,
        };

        const dialogRef = this.dialog.open(PosMutationComponent, {
            disableClose: true,
            width: '700px',
            data: this.dataForArticleMutation,
            panelClass: 'swissdefault-dialog-container',
        });

        dialogRef.afterClosed().subscribe({
            next: (result) => {
                this.currProductEntry = result;
                if (this.currProductEntry) {
                    this.currProductEntry.ausArtikelStamm = !!chosenArticle;

                    this.svcSA.saveProdToIndexedDB(this.currProductEntry).then((res) => {
                        if (res) {
                            this.loadProductEntries();
                        }
                    });
                }
            },
        });
    }

    editArticle() {
        if (this.isProductSelected && !this.currTerminFinished) {

            this.dataForArticleMutation = {
                sA_Termin: this.currTermin,
                sA_Anwender: this.currAnwender,
                produkt: this.currProdukt,
                editProdukt: this.currProductEntry,
            };

            var dialogRef = this.dialog.open(PosMutationComponent, {
                disableClose: true,
                width: '700px',
                data: this.dataForArticleMutation,
                panelClass: 'swissdefault-dialog-container',
            });

            dialogRef.afterClosed().subscribe({
                next: async (result: SA_ProductEntry) => {
                    this.currProductEntry = result;
                    await this.svcSA.updProdInIndexedDB(this.currProductEntry!);
                    this.loadProductEntries();
                }
            });
        }
    }

    delArticle() {
        if (this.isProductSelected && !this.currTerminFinished) {
            if (this.currProductEntry) {
                this.svcMessageBox
                    .askYesNoQuestion(
                        'MAIN_APP_DIALOG.DEL_ARTICLE.msg',
                        'MAIN_APP_DIALOG.DEL_ARTICLE.title',
                        [this.currProductEntry.bezeichnung]
                    )
                    .then((value) => {
                        if (value) {
                            this.svcSA
                                .delProdInIndexedDB(this.currProductEntry!)
                                .then((res) => {
                                    this.loadProductEntries();
                                });
                        }
                    });
            }
        }
    }

    /* Artikelstamm anzeigen und Produkt auswählen */
    showArticles(): void {
        if (!this.currTerminExists) {
            this.svcMessageBox.showInfoByLangagueKey('MAIN_APP_SERVICE_APP.noAppointmentSelected', 'MAIN_APP_SERVICE_APP.noAppointmentSelected');
            return;
        }
        if (this.currTerminFinished) {
            return this.svcMessageBox.showWarning('Der Termin ist bereits abgeschlossen', '');
        }

        if (this.swissSettings.getWebConfig().debugMode) {
            console.log('currTerminExists', this.currTerminExists);
        }

        var dialogRef = this.dialog.open(ArtikelstammComponent, {
            disableClose: true,
            width: '800px',
            panelClass: 'swissdefault-dialog-container',
        });

        dialogRef.afterClosed().subscribe({
            next: (result) => {
                let productNo = String(result);
                let product: ServiceAppModels.Produkt = this.svcSA
                    .getDBProdukte()
                    .filter((p) => p.productNo === productNo)[0];
                if (product) {
                    this.currProdukt = product;
                    if (this.swissSettings.getWebConfig().debugMode) {
                        console.log('Ermitteltes Produkt', this.currProdukt);
                    }
                    this.addArticle();
                } else {
                    if (this.swissSettings.getWebConfig().debugMode) {
                        console.log(
                            'Ermitteltes Produkt sollte nicht mehr da sein.',
                            this.currProdukt
                        );
                    }
                }
                this.currProdukt = undefined;
            },
        });
    }

    // Summenübersteuerung
    public customAggregateFn = (sdata: String) =>
        formatCurrency(this.totalSumme, 'de-CH', 'CHF', '1.2-2').replace(',', '.');
}
